import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3e4bd956"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "step-four"
};
var _hoisted_2 = {
  class: "entrance-header"
};
var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 开始作答 ");
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "check-tips"
  }, "验证结束等待开始吧！", -1);
});
var _hoisted_5 = {
  class: "count-down"
};
var _hoisted_6 = {
  class: "num"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "unit"
  }, "时", -1);
});
var _hoisted_8 = {
  class: "num"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "unit"
  }, "分", -1);
});
var _hoisted_10 = {
  class: "num"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "unit"
  }, "秒", -1);
});
var _hoisted_12 = {
  class: "contest-tips"
};
var _hoisted_13 = {
  class: "tips-item"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "name"
  }, "活动名称", -1);
});
var _hoisted_15 = {
  class: "desc"
};
var _hoisted_16 = {
  key: 0,
  class: "tips-item"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "name"
  }, "姓名", -1);
});
var _hoisted_18 = {
  class: "desc"
};
var _hoisted_19 = {
  key: 1,
  class: "tips-item"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "name"
  }, "开始时间", -1);
});
var _hoisted_21 = {
  class: "desc"
};
var _hoisted_22 = {
  class: "tips-item"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "name"
  }, "结束时间", -1);
});
var _hoisted_24 = {
  class: "desc"
};
var _hoisted_25 = {
  key: 2,
  class: "tips-item"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "name"
  }, "作答时长", -1);
});
var _hoisted_27 = {
  class: "desc"
};
import ExamInfoModal from '@/components/ExamInfoModal.vue';
import { computed, reactive, nextTick, onUnmounted } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { DaoService } from '@/services/dao.service';
import { preloadIDE, getBaseInfoText } from '@/utils';
import { EnvCheckerService } from '@/services/env/checker.service';
import moment from 'moment';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var daoService = useService(DaoService);
    var checkerService = useService(EnvCheckerService);
    var route = useRoute();
    var examInfo = reactive({
      userExamId: 0,
      visible: false,
      baseInfoText: '',
      answerRule: '',
      contestId: 0,
      commitmentLetterTitle: '',
      userName: ''
    });
    var countDownTimeData = computed(function () {
      return checkerService.countDownTimeData;
    });
    // const isContestRoute = computed(() => {
    //   return Boolean(route.meta.platform);
    // });
    var contestShowName = computed(function () {
      return checkerService.examDetail.contestInfoName || '';
    });
    var contestStartTime = computed(function () {
      return moment(checkerService.examDetail.startTimestamp).format('YYYY-MM-DD HH:mm:ss');
    });
    var contestEmdTime = computed(function () {
      return moment(checkerService.examDetail.endTimestamp).format('YYYY-MM-DD HH:mm:ss');
    });
    var contestAnswerDuration = computed(function () {
      var _a;
      if (!((_a = checkerService.examDetail) === null || _a === void 0 ? void 0 : _a.answerDuration)) return '';
      var minutes = checkerService.examDetail.answerDuration;
      return "".concat(minutes ? "".concat(minutes, "\u5206\u949F") : '');
    });
    var dispersesTimer;
    var onStartExam = function () {
      var userExamId = Number(checkerService.userExamId || '');
      var contestInfoId = Number(checkerService.contestInfoId || '');
      if (!userExamId) {
        _message.error('缺少必要参数，无法查看相关信息');
        return;
      }
      var showAction = function () {
        daoService.getExamInfo(userExamId).then(function (info) {
          examInfo.baseInfoText = getBaseInfoText(info.questionInfoList);
          examInfo.answerRule = info.answerRule;
          preloadIDE(); // 预加载ide
          examInfo.userExamId = userExamId;
          examInfo.visible = true;
          examInfo.contestId = contestInfoId;
          examInfo.userName = info.userName || '';
          examInfo.commitmentLetterTitle = info.commitmentLetterTitle || '';
          // checkerService.uninstall();
        }).catch(function (e) {
          if (e.errCode === 5013) {
            clearTimeout(dispersesTimer);
            // 生成0到10000毫秒之间的随机数
            var randomDelay = Math.floor(Math.random() * 3000);
            // 最后一次校验是否符合 打散时间 随机0~3s
            dispersesTimer = setTimeout(checkerService.getExamDuration, randomDelay);
          }
        });
      };
      nextTick(function () {
        showAction();
      });
    };
    checkerService.getExamDuration();
    onUnmounted(function () {
      clearTimeout(dispersesTimer);
    });
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: !_unref(checkerService).examDetailGeted
      }, {
        default: _withCtx(function () {
          var _a, _b, _c, _d, _e;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(checkerService).isCanEntrance ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            class: "start-exam",
            onClick: onStartExam
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(countDownTimeData).h), 1), _hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(countDownTimeData).min), 1), _hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(countDownTimeData).sec), 1), _hoisted_11])], 64))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString((_a = _unref(contestShowName)) !== null && _a !== void 0 ? _a : '--'), 1)]), _unref(checkerService).examDetail.userName ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString((_b = _unref(checkerService).examDetail.userName) !== null && _b !== void 0 ? _b : '--'), 1)])) : _createCommentVNode("", true), _unref(checkerService).examDetail.startTimestamp ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString((_c = _unref(contestStartTime)) !== null && _c !== void 0 ? _c : '--'), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString((_d = _unref(contestEmdTime)) !== null && _d !== void 0 ? _d : '--'), 1)]), _unref(contestAnswerDuration) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString((_e = _unref(contestAnswerDuration)) !== null && _e !== void 0 ? _e : '--'), 1)])) : _createCommentVNode("", true)])]), _createVNode(ExamInfoModal, {
            data: _unref(examInfo)
          }, null, 8, ["data"])];
        }),
        _: 1
      }, 8, ["spinning"]);
    };
  }
});